
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增公文转发
export function addOfficialForwarding(params) {
    return post(`${HOST}official-forwarding/save`, params)
}
// 修改公文转发
export function updateOfficialForwarding(params) {
    return post(`${HOST}official-forwarding/update`, params)
}
//公文转发
export function getOfficialForwarding(params) {
    return get(`${HOST}official-forwarding/list`, params)
}
//公文转发草稿箱列表
export function OfficialForwardingDraftlist(params) {
    return get(`${HOST}official-forwarding/draftlist`, params)
}
//公文转发详情
export function OfficialForwardingDetial(params) {
    return get(`${HOST}official-forwarding/get`, params)
}
// 删除公文转发
export function delOfficialForwarding(params) {
    return del(`${HOST}official-forwarding/delete`, params)
}
// 历史记录
export function getHistoryList(params) {
    return get(`${HOST}official-forwarding-history/list`, params)
}
//历史记录详情
export function getHistoryVersion(params) {
    return get(`${HOST}official-forwarding-history/get`, params)
}
// 浏览人
export function getPersonalCounts(params) {
    return get(`${HOST}official-forwarding/getPersonalCounts`, params)
}






// WEBPACK FOOTER //
// ./src/views/InformTheForwarding/api/api.js